import LeadRoutes from './routes'
export default LeadRoutes



// WEBPACK FOOTER //
// ./src/pages/lead/routes/index.js